export const tableDataSchemas = [
  {
    prop: 'name',
    label: '加密狗版本名称',
    minWidth: 120
  },
  {
    prop: 'dongleFunType',
    label: '加密狗功能类型'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    minWidth: 120
  }
]

/* eslint-disable */
export const DONGLE_FUN_TYPE = {
  [1]: '主版本',
  [2]: '选配版本',
  [3]: '医保功能'
}

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    label: '加密狗版本名称',
    placeholder: '请输入加密狗版本名称',
    rules: [
      {
        required: true,
        message: '加密狗版本名称不能为空',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'dongleFunType',
    defaultValue: 1,
    component: 'Radio',
    label: '加密狗功能类型',
    radioArr: [
      {
        label: '主版本',
        value: 1
      },
      {
        label: '选配功能',
        value: 2
      },
      {
        label: '医保功能',
        value: 3
      }
    ],
    rules: [
      {
        required: true,
        message: '功能类型不能为空',
        trigger: ['blur']
      }
    ]
  },
  // {
  //   field: 'moduleConfig',
  //   defaultValue: '',
  //   component: 'InputTextArea',
  //   type: 'number',
  //   label: '加密狗授权模块功能',
  //   placeholder: '请输入加密狗授权模块功能,例如911;101',
  //   rules: [
  //     {
  //       required: true,
  //       message: '加密狗授权模块功能不能为空',
  //       trigger: ['blur']
  //     }
  //   ]
  // }
  {
    field: 'number',
    defaultValue: '',
    component: 'InputTextArea',
    type: 'number',
    label: '加密狗授权模块编号',
    placeholder: '请输入加密狗授权模块编号',
    rules: [
      {
        required: true,
        message: '加密狗授权模块编号不能为空',
        trigger: ['blur']
      }
    ]
  }
]

export const options = []
